/**
 * Mensajes de error de carga de Informes (puro; testeable en Node).
 */
import { isReportsAuthorizationError } from './reportsKpiDataSourceFormat';

export function isReportsTechnicalLoadError(message: string) {
  const lower = message.toLowerCase();
  return (
    lower.includes('network request failed') ||
    lower.includes('failed to fetch') ||
    lower.includes('fetch failed') ||
    lower.includes('edge function returned a non-2xx') ||
    lower.includes('invalid jwt') ||
    lower.includes('jwt') ||
    lower.includes('timeout') ||
    lower.includes('postgres') ||
    lower.includes('supabase') ||
    lower.includes('rpc') ||
    lower.includes('socket hang up')
  );
}

export function formatReportsLoadError(error: unknown) {
  const rawMessage = String((error as { message?: string } | undefined)?.message ?? '');

  if (isReportsAuthorizationError(rawMessage)) {
    return 'No tenés permiso para ver los informes. Pedile al dueño que te habilite el acceso.';
  }

  if (isReportsTechnicalLoadError(rawMessage)) {
    return 'No se pudieron cargar los datos. Revisá la conexión y reintentá.';
  }

  if (rawMessage.trim().length > 0) {
    return rawMessage;
  }

  return 'No se pudieron cargar los datos. Reintentá.';
}
